import { render, staticRenderFns } from "./CampanhaInternaCampanhasApp.vue?vue&type=template&id=18c0a670&scoped=true"
import script from "./CampanhaInternaCampanhasApp.vue?vue&type=script&lang=js"
export * from "./CampanhaInternaCampanhasApp.vue?vue&type=script&lang=js"
import style0 from "./CampanhaInternaCampanhasApp.vue?vue&type=style&index=0&id=18c0a670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c0a670",
  null
  
)

export default component.exports